import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/useAuthContext'
import { sessionManager } from '../utils/session'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'

export const useSessionManager = () => {
  const [showTimeoutWarning, setShowTimeoutWarning] = useState(false)
  const navigate = useNavigate()
  const { user, signOut } = useAuth()
  const { t } = useTranslation()
  
  const handleSessionTimeout = useCallback(async () => {
    // Sign out and redirect to login
    try {
      await signOut()
      message.warning(t('auth.sessionExpired'))
      navigate('/auth/login', { 
        state: { from: window.location.pathname } 
      })
    } catch (error) {
      console.error('Error during session timeout:', error)
    }
  }, [signOut, navigate, t])
  
  const handleSessionWarning = useCallback(() => {
    setShowTimeoutWarning(true)
  }, [])
  
  const handleExtendSession = useCallback(() => {
    setShowTimeoutWarning(false)
    message.success('Session extended')
  }, [])
  
  const handleLogoutNow = useCallback(async () => {
    setShowTimeoutWarning(false)
    await handleSessionTimeout()
  }, [handleSessionTimeout])
  
  useEffect(() => {
    // Only initialize session manager if user is logged in
    if (!user) {
      sessionManager.clear()
      return
    }
    
    // Initialize session manager
    sessionManager.init({
      onTimeout: handleSessionTimeout,
      onWarning: handleSessionWarning,
    })
    
    // Cleanup on unmount or user change
    return () => {
      sessionManager.clear()
    }
  }, [user, handleSessionTimeout, handleSessionWarning])
  
  return {
    showTimeoutWarning,
    handleExtendSession,
    handleLogoutNow,
  }
}